const Pencil = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_1838_527"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="2"
        width="14"
        height="20"
      >
        <path
          d="M19.2641 6.71741C20.0944 5.27919 19.6017 3.44014 18.1635 2.60979C16.7252 1.77943 14.8862 2.2722 14.0558 3.71042L6.53838 16.731L6.79073 20.6438C6.83666 21.3559 7.59223 21.7921 8.23189 21.4759L11.7466 19.738L19.2641 6.71741Z"
          fill="#F23B3B"
        />
      </mask>
      <g mask="url(#mask0_1838_527)">
        <rect
          x="16.6328"
          y="11.2744"
          width="3.75873"
          height="1.50349"
          transform="rotate(-150 16.6328 11.2744)"
          fill="#D9CCB9"
        />
        <rect
          x="17.3848"
          y="9.97266"
          width="3.75873"
          height="1.50349"
          transform="rotate(-150 17.3848 9.97266)"
          fill="#F7F3F0"
        />
        <rect
          x="13.3779"
          y="9.39551"
          width="2.25524"
          height="1.50349"
          transform="rotate(-150 13.3779 9.39551)"
          fill="#C6C6C6"
        />
        <rect
          x="14.1299"
          y="8.09375"
          width="2.25524"
          height="1.50349"
          transform="rotate(-150 14.1299 8.09375)"
          fill="#DDDDDD"
        />
        <path
          d="M19.2641 6.7174C20.0944 5.27919 19.6017 3.44014 18.1635 2.60979C16.7252 1.77943 14.8862 2.2722 14.0558 3.71042L12.9282 5.66351L18.1365 8.6705L19.2641 6.7174Z"
          fill="#F29090"
        />
        <path
          d="M18.8145 2.98535L15.5593 1.10599L12.9282 5.6632L14.8813 6.79082C14.8813 6.79082 15.821 5.16324 16.3848 4.1867C17.1365 2.88464 18.8145 2.98535 18.8145 2.98535Z"
          fill="#E33434"
        />
        <path d="M16.6328 11.2744L13.3777 9.39505L8.49131 17.8585L11.7465 19.7378L16.6328 11.2744Z" fill="#FFCC5B" />
        <path d="M13.3779 9.39551L11.4248 8.26789L6.53849 16.7313L8.49158 17.8589L13.3779 9.39551Z" fill="#FDBC4B" />
        <path d="M11.7473 19.7384L6.53906 16.7314L6.88795 22.1411L11.7473 19.7384Z" fill="#F4CF9D" />
        <path d="M6.88795 22.1411L8.61624 21.4029L8.49215 17.8591L6.53906 16.7314L6.88795 22.1411Z" fill="#EEBF86" />
        <path d="M9.31701 20.939L6.71289 19.4355L6.88733 22.1404L9.31701 20.939Z" fill="#51504E" />
      </g>
    </svg>
  );
};

export default Pencil;
